import {
    ADD_CASE_FILE,
    FETCH_CASE_FAILURE,
    FETCH_CASE_START,
    FETCH_CASE_SUCCESS,
    MARK_CASE_SLIDE_READ,
    REMOVE_CASE_FILE
} from "../redux_constants/case.constant";


const initialState = {
    case: null,
    loading: false,
    error: null,
    case_files: []
};

export const caseReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CASE_START:
            return {
                case: null,
                loading: true,
                error: null,
                case_files: []
            };
        case FETCH_CASE_SUCCESS:
            return {
                ...state,
                loading: false,
                case: action.payload,
                case_files: action.payload.files
            };
        case FETCH_CASE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case ADD_CASE_FILE:
            return {
                ...state,
                case_files: [...state.case_files, action.payload]
            }
        case REMOVE_CASE_FILE:
            const case_files = state.case_files.filter(file => file.id !== action.fileId)
            return {
                ...state,
                case_files
            }
        case MARK_CASE_SLIDE_READ:
            if (state.case && state.case.slides) {
                return {
                    ...state,
                    case: {
                        ...state.case,
                        slides: state.case.slides.map(slide => {
                                return slide.id === action.slideId ? {...slide, unread: action.unread} : slide
                            }
                        )
                    }
                };
            } else {
                return state;
            }

        default:
            return state;
    }
};
